import { loading } from 'State/actions';
import * as types from './types';

export const clearAssignSiteData = () => {
  return {
    type: types.SITESETUP_CLEAR_ASSIGN_USER_DATA,
  };
};

export const updateAssignUserData = (item, key) => {
  return {
    type: types.SITESETUP_UPDATE_ASSIGN_USER_DATA,
    payload: { item, key },
  };
};

export const getUsersForAssign = siteId => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SITESETUP_SET_ASSIGN_LOADING, true));

    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Usermaster/GetAllUsersAccessibleFunctions',
        `'${siteId}'`
      );
      dispatch({
        type: types.SITESETUP_SET_ASSIGN_USER_DATA,
        payload: response,
      });
    } catch (error) {}

    dispatch(loading(types.SITESETUP_SET_ASSIGN_LOADING, false));
  };
};

export const checkAll = (checkAll, currentRows, fieldName) => {
  return {
    type: types.SITESETUP_CHECKALL_ASSIGN_USER_DATA,
    payload: { checkAll, currentRows, fieldName },
  };
};
export const updateIsPageAccessible = (
  currentRows,
  fieldName,
  userName,
  index
) => {
  return {
    type: types.SITESETUP_UPDATE_IS_PAGE_ACCESSIBLE,
    payload: { currentRows, fieldName, userName, index },
  };
};



// WEBPACK FOOTER //
// ./src/pages/sitesetup/state/assignUsers/actions.js